import script from "./LikeAdmin.vue?vue&type=script&lang=ts&setup=true"
export * from "./LikeAdmin.vue?vue&type=script&lang=ts&setup=true"

import "./LikeAdmin.vue?vue&type=style&index=0&id=57260362&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57260362"]])

export default __exports__